/** @format */

import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon, Tooltip, Button } from '@king-design/react'
import variable from 'src/static/styles/var'

export type IconButtonType = 'download' | 'settings' | 'delete' | 'refresh'

const ICON_TYPE_CLASS_MAP: Record<IconButtonType, string> = {
  download: 'k-icon-download',
  settings: 'k-icon-settings',
  delete: 'k-icon-delete',
  refresh: 'k-icon-refresh'
}

export interface IconButtonProps {
  className?: string
  /** 预设图标类型 */
  type?: IconButtonType
  /** 自定义图标 class，如 k-icon-edit；优先级高于 type */
  icon?: string
  /** Tooltip 文案 */
  title: string
  /** hover 时是否展示背景色 */
  hoverBackground?: boolean
  disabled?: boolean
  onClick?: () => void
  iconSize?: number
}

const IconButton: FC<IconButtonProps> = ({
  className,
  type,
  icon,
  title,
  hoverBackground = false,
  disabled,
  onClick,
  iconSize = 16
}) => {
  const iconClassName = icon || ICON_TYPE_CLASS_MAP[type]

  return iconClassName ? (
    <Tooltip disabled={!title} content={title} theme="dark">
      <Button
        type="none"
        className={['icon-button', className].filter(Boolean).join(' ')}
        data-hover-background={hoverBackground || undefined}
        disabled={disabled}
        onClick={onClick}
        aria-label={title}
      >
        <Icon className={iconClassName} size={iconSize} />
      </Button>
    </Tooltip>
  ) : null
}

export default styled(IconButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  .k-icon {
    color: ${variable.fontColor};
    transition: color 0.2s;
    margin-right: 0;
  }

  &:hover:not(:disabled) {
    background: transparent;
    .k-icon {
      color: ${variable.primaryColor};
    }
  }

  &[data-hover-background]:hover:not(:disabled) {
    background: #edeff0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
